const STORAGE_KEY = "recentlyViewedProducts";
const MAX_ITEMS = 24;

export function getRecentlyViewedIds() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter((entry) => entry && Number.isFinite(entry.id))
      .sort((a, b) => (b.viewedAt || 0) - (a.viewedAt || 0))
      .map((entry) => entry.id);
  } catch {
    return [];
  }
}

export function addRecentlyViewed(productId) {
  const id = Number(productId);
  if (!Number.isFinite(id)) return;

  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    const list = Array.isArray(parsed) ? parsed : [];
    const now = Date.now();
    const without = list.filter((entry) => entry?.id !== id);
    const next = [{ id, viewedAt: now }, ...without].slice(0, MAX_ITEMS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    /* ignore quota / private mode */
  }
}

export function orderProductsByRecent(products, recentIds) {
  if (!recentIds?.length) return [];
  const byId = new Map(products.map((p) => [p.id, p]));
  return recentIds.map((id) => byId.get(id)).filter(Boolean);
}
